import { Environment, EnvironmentMapping } from 'utils/Enums';

type ConfigModule = { config: any };

// export function getCustomerConfig() {
//     const configMap: Record<string, () => ConfigModule> = {
//         kind_staging: () => require('./customers/kind/kind_staging'),
//         kind_prod: () => require('./customers/kind/kind_staging'),
//         kind_test: () => require('./customers/kind/kind_staging'),
//         kind_dev: () => require('./customers/kind/kind_staging'),
//         truFru_staging: () => require('./customers/truFru/truFru_staging'),
//         truFru_prod: () => require('./customers/truFru/truFru_staging'),
//         truFru_test: () => require('./customers/truFru/truFru_staging'),
//         truFru_dev: () => require('./customers/truFru/truFru_staging'),
//         perrigo_staging: () => require('./customers/perrigo/perrigo_staging'),
//         perrigo_prod: () => require('./customers/perrigo/perrigo_staging'),
//         perrigo_test: () => require('./customers/perrigo/perrigo_staging'),
//         perrigo_dev: () => require('./customers/perrigo/perrigo_staging'),
//         constellation_staging: () => require('./customers/constellation/constellation_staging'),
//         constellation_prod: () => require('./customers/constellation/constellation_staging'),
//         constellation_test: () => require('./customers/constellation/constellation_staging'),
//         constellation_dev: () => require('./customers/constellation/constellation_staging'),
//         demo_staging: () => require('./customers/demo/demo_staging'),
//         demo_prod: () => require('./customers/demo/demo_staging'),
//         demo_test: () => require('./customers/demo/demo_staging'),
//         demo_dev: () => require('./customers/demo/demo_staging'),
//         naturesBakery_staging: () => require('./customers/naturesBakery/naturesBakery_staging'),
//         naturesBakery_prod: () => require('./customers/naturesBakery/naturesBakery_staging'),
//         naturesBakery_test: () => require('./customers/naturesBakery/naturesBakery_staging'),
//         naturesBakery_dev: () => require('./customers/naturesBakery/naturesBakery_staging'),
//         gp_staging: () => require('./customers/gp/gp_staging'),
//         gp_prod: () => require('./customers/gp/gp_staging'),
//         gp_test: () => require('./customers/gp/gp_staging'),
//         gp_dev: () => require('./customers/gp/gp_staging'),
//         nomadFoods_staging: () => require('./customers/nomadFoods/nomadFoods_staging'),
//         nomadFoods_prod: () => require('./customers/nomadFoods/nomadFoods_staging'),
//         nomadFoods_test: () => require('./customers/nomadFoods/nomadFoods_staging'),
//         nomadFoods_dev: () => require('./customers/nomadFoods/nomadFoods_staging'),
//         perrigoSpain_staging: () => require('./customers/perrigoSpain/perrigoSpain_staging'),
//         perrigoSpain_prod: () => require('./customers/perrigoSpain/perrigoSpain_staging'),
//         perrigoSpain_test: () => require('./customers/perrigoSpain/perrigoSpain_staging'),
//         perrigoSpain_dev: () => require('./customers/perrigoSpain/perrigoSpain_staging'),
//         perrigoBelgium_staging: () => require('./customers/perrigoBelgium/perrigoBelgium_staging'),
//         perrigoBelgium_prod: () => require('./customers/perrigoBelgium/perrigoBelgium_staging'),
//         perrigoBelgium_test: () => require('./customers/perrigoBelgium/perrigoBelgium_staging'),
//         perrigoBelgium_dev: () => require('./customers/perrigoBelgium/perrigoBelgium_staging'),
//         cooper_staging: () => require('./customers/cooper/cooper_staging'),
//         cooper_prod: () => require('./customers/cooper/cooper_staging'),
//         cooper_test: () => require('./customers/cooper/cooper_staging'),
//         cooper_dev: () => require('./customers/cooper/cooper_staging'),
//     };
//     const customerEnv = process.env.REACT_APP_CUSTOMER_ENV || 'staging';
//     const key = `${process.env.REACT_APP_TENANT_ID}_${customerEnv}`;

//     const loader = configMap[key];

//     if (!loader) {
//         throw new Error(`Unknown tenant/env: ${key}`);
//     }

//     return loader().config;
// }

export async function getCustomerConfig() {
    let mappedEnv;
    const tenant = process.env.REACT_APP_TENANT_ID || '';
    const env = process.env.REACT_APP_CUSTOMER_ENV || Environment.staging;

    //for customers that are enabled for prod, we will map the config to prod
    const prodEnabledCustomers: string[] = [];
    if (prodEnabledCustomers.includes(tenant) && env === Environment.prod) {
        mappedEnv = Environment.prod;
    } else {
        mappedEnv = EnvironmentMapping?.[env as keyof typeof EnvironmentMapping] || Environment.staging;
    }
    if (!tenant) {
        throw new Error('REACT_APP_TENANT_ID not defined');
    }

    const module = await import(
        /* webpackChunkName: "customer-config-[request]" */
        `./customers/${tenant}/${tenant}_${mappedEnv}`
    );

    return module.config;
}
